import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import fr from 'react-intl/locale-data/fr';
import get from 'lodash/get';
import smoothscroll from 'smoothscroll-polyfill';

import ApplicationLayout from 'components/Layout/ApplicationLayout';
import LandingPage from 'components/Layout/LandingPage';
import { AuthSubject } from 'shared/AuthSubject';
import { LayoutSubject } from 'shared/LayoutSubject';
import { LanguageSubject } from 'shared/LanguageSubject';
import Auth from 'shared/Auth';
import localeMessages from '../../data/locale.json';

class BaseLayout extends Component {
  constructor(props) {
    super(props);

    addLocaleData([...fr]);

    this.state = {
      profile: Auth.isAuthenticated(),
      showHome: false,
      activeRoute: '',
      locale: {
        local_locale: '',
        lang: '',
      },
    };

    this.authListener = null;
    this.layoutListener = null;
  }

  componentDidMount() {
    smoothscroll.polyfill();
    
    this.authListener = AuthSubject.subscribe(newState => {
      this.setState(newState);

      Auth.setLanguage(get(newState, 'locale'));
    });

    this.layoutListener = LayoutSubject.subscribe(layout => {
      this.setState({ ...layout });
    });

    if (!get(Auth.getLanguage(), 'lang')) {
      Auth.setLanguage({
        lang: 'en_US',
        local_locale: 'en',
      });
    }

    this.setState({ locale: Auth.getLanguage() });
  }

  componentWillUnmount() {
    if (this.authListener !== null) {
      this.authListener.unsubscribe();
      this.authListener = null;
    }

    if (this.layoutListener !== null) {
      this.layoutListener.unsubscribe();
      this.layoutListener = null;
    }
  }

  changeLanguage = (lang = 'en_US', local_locale = 'en') => {
    Auth.setLanguage(lang, local_locale);

    this.setState({ locale: Auth.getLanguage() });

    LanguageSubject.next({ locale: Auth.getLanguage() });
  };

  render() {
    let activeLayout;

    const messages = localeMessages[get(this.state.locale, 'local_locale')];

    const defaultLocale = { lang: 'en_US', local_locale: 'en_US' };

    if (this.state.profile && !this.state.showHome) {
      activeLayout = <ApplicationLayout />;
    } else {
      activeLayout = (
        <LandingPage
          changeLanguage={this.changeLanguage}
          currentLocale={this.state.locale}
          defaultLocale={defaultLocale}
          activeRoute={this.state.activeRoute}
          showHome={this.state.showHome}
        />
      );
    }

    return (
      <IntlProvider locale={get(this.state.locale, 'local_locale')} messages={messages}>
        <BrowserRouter>
          <div>{activeLayout}</div>
        </BrowserRouter>
      </IntlProvider>
    );
  }
}

export default BaseLayout;



// WEBPACK FOOTER //
// ./src/components/Layout/BaseLayout.js